<template>
  <div
    class="text-center mt-10"
  >
    <h2>{{ $t('login.login_with_sorare') }}</h2>
    <sorare-connect-button class="my-5" />
    <div>
      {{ $t('login.dont_have_sorare_account') }}
      <a
        id="affiliate-link"
        :href="affiliateLink"
        target="_blank"
      >
        {{ $t('login.create_one_now') }}
      </a>
    </div>
    <div
      class="mt-5 sorare-ad"
    >
      <a
        :href="affiliateLink"
        target="_blank"
      >
        <v-img
          :src="sorareAd"
          cover
          alt="Sorare ad"
        />
      </a>
    </div>
  </div>
</template>

<script>
import SorareConnectButton from '@/components/SorareConnectButton.vue';
import sorareAd from '@/assets/sorare-ad.png';

export default {
  name: 'Login',
  components: {
    SorareConnectButton,
  },
  data() {
    return {
      sorareAd,
    };
  },
  computed: {
    affiliateLink() {
      return this.$consts.AFFILIATE_LINK;
    },
  },
};
</script>

<style scoped>
#affiliate-link {
  text-decoration: underline !important;
}

.sorare-ad {
  width: 60%;
  margin: 0 20%;
}

@media (max-width: 600px) {
  .sorare-ad {
    width: 80%;
    margin: 0 10%;
  }
}
</style>
